import gql from "graphql-tag";

export const GET_USER = gql`
  query getUser {
    User {
      id
      email
      firstName
      lastName
      photoUrl
      emailVerified
    }
  }
`;

export const GET_MENU = gql`
  query getMenu {
    Menu {
      name
      id
      bannerUrl
      pdfUrl
      menuType
      Categories(order_by: { sortIndex: asc }) {
        sortIndex
        name
        id
        Dishes(order_by: { sortIndex: asc }) {
          sortIndex
          inStock
          price
          name
          id
        }
      }
    }
  }
`;

export const GET_MENU_TYPE = gql`
  query getMenuType {
    Menu {
      name
      id
      menuType
      pdfUrl
    }
  }
`;
export const GET_MENU_DISHES = gql`
  query getMenuDishes($dishId: uuid!) {
    Dish(where: { id: { _eq: $dishId } }) {
      id
      name
      photoUrl
      description
      inStock
      price
      availableTo
      availableFrom
      sortIndex
      DishModifiers(order_by: { sortIndex: asc }) {
        id
        sortIndex
        Modifier {
          name
          menuId
          id
          itemMax
          totalMax
          totalMin
          ModifierItems(order_by: { sortIndex: asc }) {
            price
            name
            id
            sortIndex
          }
        }
      }
    }
  }
`;

export const GET_MODIFIERS = gql`
  query getModifiers {
    Modifier {
      name
      menuId
      id
      itemMax
      totalMax
      totalMin
      ModifierItems(order_by: { sortIndex: asc }) {
        price
        name
        id
        sortIndex
      }
    }
  }
`;
